import { incApi } from 'api/inc-api';
import { getClientId } from 'util/client-id';
import { Paging } from 'components/search/search.hooks';
import {
  AssignTransactionRequest,
  AssignTransactionResult,
  DepositsSummary,
  GeneratePayoutDetails,
  ListCustomerTransactionsParams,
  ListDepositsSummaryParams,
  Transaction,
} from './transactions.types';

const endpoints = incApi.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    listCustomerTransactions: build.query<
      { transactions: Transaction[] } & Paging,
      ListCustomerTransactionsParams
    >({
      query: params => ({
        url: `incentivio-transactions/clients/${getClientId()}/transactions`,
        method: 'GET',
        params,
      }),
      providesTags: (_result, _error, arg) => [
        { type: 'CustomerTransactions', id: arg.userid },
      ],
    }),

    listDepositsSummary: build.query<
      { content: DepositsSummary[] } & Paging,
      ListDepositsSummaryParams
    >({
      query: params => ({
        url: `incentivio-payments/payouts`,
        method: 'GET',
        params,
      }),
    }),

    generateDetails: build.query<GeneratePayoutDetails, string>({
      query: payoutId => ({
        url: `incentivio-payments/payouts/payout-summary/${payoutId}`,
        method: 'GET',
      }),
    }),

    assignTransaction: build.mutation<
      AssignTransactionResult,
      AssignTransactionRequest
    >({
      query: (body: AssignTransactionRequest) => ({
        url: 'incentivio-transactions/assigntransaction',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, body) => [
        { type: 'CustomerTransactions', id: body.userId },
        { type: 'LoyaltyHistory', id: body.userId },
        { type: 'AccountLoyaltySummary', id: body.userId },
      ],
    }),
  }),
});

export const {
  useListCustomerTransactionsQuery,
  useListDepositsSummaryQuery,
  useGenerateDetailsQuery,
  useAssignTransactionMutation,
} = endpoints;
